"use client";
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnleashClient = exports.useUnleashContext = exports.useFlagsStatus = exports.useFlags = exports.useVariant = exports.useFlag = void 0;
const proxy_client_react_1 = require("@unleash/proxy-client-react");
const useFlag = (name) => (0, proxy_client_react_1.useFlag)(name);
exports.useFlag = useFlag;
const useVariant = (name) => (0, proxy_client_react_1.useVariant)(name);
exports.useVariant = useVariant;
const useFlags = () => (0, proxy_client_react_1.useFlags)();
exports.useFlags = useFlags;
exports.useFlagsStatus = proxy_client_react_1.useFlagsStatus;
exports.useUnleashContext = proxy_client_react_1.useUnleashContext;
exports.useUnleashClient = proxy_client_react_1.useUnleashClient;
